import { Component, IterableDiffers, OnInit } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { Mmpi2Service } from 'src/app/services/mmpi2.service';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-mmpi2-questions',
  templateUrl: './mmpi2-questions.component.html',
  styleUrls: ['./mmpi2-questions.component.css']
})
export class Mmpi2QuestionsComponent implements OnInit {

  public questions = [];
  public scales = [];
  public valueIndex = 1;
  public trueItems = [];
  public falseItems = [];
  public dualItems = [];
  public allScales = [];
  public subscales = [];
  public selectedScale = "";
  public selectedSubscale = "";
  public text = "";
  public value = false;
  public isPair = false;
  public equal = false;
  public index = 999;
  public pair = 0;
  public _id = "";
  public editingIndex = 0;

  public dualForm = {
    index1:1,
    index2:1,
    value1:true,
    value2:true,
    scale:""
  }

  public loadingScales = false;

  public isEditing = false;

  constructor(
    private mmpi2Service:Mmpi2Service,
    private adminService:AdminServiceService
  ) { }

  ngOnInit(): void {
    this.loadingScales = true;
    this.mmpi2Service.getScales().subscribe(
      resp=>{
        this.allScales = resp.all;
        let scalesArray = [];
        this.allScales.map(
          scale=>{
            if(scale.type=='basicas') {
              if (scale.scale=='L'||scale.scale=='?'||scale.scale=='F'||scale.scale=='K'||scale.scale=='FB'||scale.scale=='VRIN'||scale.scale=='TRIN') scalesArray.push(scale)
            }          
          }
        )
        this.scales = scalesArray;
        this.loadingScales = false;
      },
      err=>console.log(err)
    )
    this.mmpi2Service.getQuestion().subscribe(
      resp=>{
        this.questions = resp;
      },
      err=>console.log(err)
    )
  }

  handleDelete(id){
    let opc = confirm("Eliminar pregunta?");
    if (opc) this.adminService.deleteQuestion('mmpi2',id);
  }

  changeType(e){
    let scalesArray = [];
    this.allScales.map(
      scale=>{
        if(e=='validez'&&scale.type=='basicas') {
          if (scale.scale=='L'||scale.scale=='?'||scale.scale=='F'||scale.scale=='K'||scale.scale=='FB'||scale.scale=='VRIN'||scale.scale=='TRIN') scalesArray.push(scale)
        }
        if(e=='clinicas'&&(scale.type=='basicas')) {
          if (scale.scale!='L'&&scale.scale!='?'&&scale.scale!='F'&&scale.scale!='K'&&scale.scale!='FB'&&scale.scale!='F(P)'&&scale.scale!='VRIN'&&scale.scale!='TRIN') scalesArray.push(scale)
        }
        if(e=='lingoes'&&(scale.type=='lingoes')) {
          scalesArray.push(scale)
        }
        if(e=='contenido'&&scale.type=='contenido') scalesArray.push(scale)
        if(e=='suplementarias'&&scale.type=='suplementarias') scalesArray.push(scale)
      }
    )
    this.scales = scalesArray;
  }

  restoreItem(i,it,t){
    let values = this.questions[it].values;
    let index = 0;
    let pos = 0;
    values.map(
      v=>{
        if (v.scale==this.selectedScale) pos = index;
        index++;
      }
    )
    values.splice(pos,1);
    let obj = {
      values: values,
      _id:this.questions[it]._id
    }
    this.mmpi2Service.updateQuestion(obj).subscribe();
    if (t){
      this.trueItems.splice(i, 1)
    }else{
      this.falseItems.splice(i,1)
    }
  }

  restoreDualItem(i,it){
    this.dualItems.splice(i, 1);
    this.questions[it.index1].equalPairs.splice(this.questions[it.index1].equalPairs.indexOf(it),1);
    let obj = {
      equalPairs: this.questions[it.index1].equalPairs,
      _id:this.questions[it.index1]._id,
    }
    this.mmpi2Service.updateQuestion(obj).subscribe();
  }

  handleEdit(q,i){
    scrollTo(0,0);
    this.editingIndex = i;
    this.isEditing = true;
    this.selectedScale = q.scale;
    this.selectedSubscale = q.subscale;
    this.text = q.text;
    this.isPair = q.isPair;
    this.equal = q.equal;
    this.pair = q.pair;
    this.value = q.value;
    this.index = q.index;
    this._id = q._id;
  }

  updateQuestion(){
    let obj = {
      text: this.text,
      scale: this.selectedScale,
      subscale: this.selectedSubscale,
      isPair: this.isPair,
      pair: this.pair,
      equal: this.equal,
      value: this.value,
      index: this.index,
      _id:this._id
    }
    this.mmpi2Service.updateQuestion(obj).subscribe(
      resp=>{
        Swal.fire("Pregunta actualizada").then(
          resp=>this.questions[this.editingIndex] = obj
        )
      },
      err=>console.log(err)
    )
  }

  addQuestion(){
    let obj = {
      text: this.text,
      scale: this.selectedScale,
      subscale: this.selectedSubscale,
      isPair: this.isPair,
      equal: this.equal,
      pair: this.pair,
      value: this.value,
      index: this.index,
    }
    this.mmpi2Service.createQuestion(obj).subscribe(
      resp=>{
        this.questions.push(obj);
        this.selectedScale = "";
        this.selectedSubscale = "";
        this.text = "";
        this.value = false;
        this.isPair = false;
        this.equal = false;
        this.index = 999;
        this.pair = 0;
      },
      err=>console.log(err)
    )
  }

  reload(){
    window.location.reload();
  }

  selectSubscale(){
    this.trueItems = [];
    this.falseItems = [];
    this.dualItems = [];
    let index = 0;
    this.questions.map(
      q=>{
        for (let type of q.values){
          if (type.scale == this.selectedScale){
            if (type.value) this.trueItems.push(index);
            else this.falseItems.push(index);
          }
        }
        // if(q.scale==this.selectedScale){
        //   if (this.selectedScale!="VRIN"&&this.selectedScale!="TRIN"){
        //     if (q.value) this.trueItems.push(index);
        //     else this.falseItems.push(index);
        //   }else{
        //   }
        // }
        if (this.selectedScale=="VRIN"||this.selectedScale=="TRIN"){          
          q.equalPairs.map(
            p=>{
              if (p.scale==this.selectedScale) {
                this.dualItems.push(p);
              }
            }
          )
        }
        index++;
      }
    )
  }

  addTrue(){
    this.trueItems.push(this.valueIndex-1);
    $('#index').focus();
    this.valueIndex=null;
  }

  addFalse(){
    this.falseItems.push(this.valueIndex-1);
    $('#index').focus();
    this.valueIndex=null;

  }

  addDual(){
    this.dualForm.scale=this.selectedScale;
    this.dualForm.index1--;
    this.dualForm.index2--;
    this.dualItems.push(this.dualForm);
    this.dualForm = {
      scale:"",
      index1:1,
      index2:1,
      value1:true,
      value2:true
    }
  }

  async setCorrelations(){
    this.loadingScales = true;
    for (let i of this.trueItems){
      let values = this.questions[i].values;
      values.push({scale:this.selectedScale, value:true});
      let obj = {
        value: true,
        values: values,
        _id:this.questions[i]._id
      }
      let res = await this.mmpi2Service.updateQuestion(obj).toPromise();
    }
    for (let i of this.falseItems){
      let values = this.questions[i].values;
      values.push({scale:this.selectedScale, value:false});
      let obj = {
        value: false,
        values: values,
        _id:this.questions[i]._id
      }
      let res = await this.mmpi2Service.updateQuestion(obj).toPromise();
    }
    this.loadingScales = false;
    this.trueItems = [];
    this.falseItems = [];
    //location.reload();
  }

  async setDualCorrelations(){
    this.loadingScales = true;
    let auxArray = [];
    for (let i of this.dualItems){
      auxArray = [];
      auxArray = this.questions[i.index1].equalPairs;
      console.log(this.questions[i.index1].equalPairs.indexOf(i))
      if (this.questions[i.index1].equalPairs.indexOf(i)<0) auxArray.push(i);
      let obj = {
        scale:this.selectedScale,
        _id:this.questions[i.index1]._id,
        isPair:true,
        equalPairs:auxArray
      }
      let res = await this.mmpi2Service.updateQuestion(obj).toPromise();
    }

    location.reload();
  }

}
